import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { sendContactEmail } from '../../ducks/user.duck';
import { injectIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  StaticPageHeader,
  ExternalLink,
  IconSuccess,
  Button,
} from '../../components';
import { ContactForm } from '../../forms';
import config from '../../config';

import heroImage from './hero.jpg';
import css from './ContactPage.module.css';

const ContactPageComponent = props => {
  const { intl, onSendContactEmail, sendContactEmailInProgress, sendContactEmailError } = props;
  const { siteTitle } = config;

  // Hook
  const [isContactFormSubmitted, setContactFormSubmitted] = useState(false);

  // Handle form submission
  const handleSubmit = values => {
    onSendContactEmail(values)
      .then(() => setContactFormSubmitted(true))
      .catch(e => {
        console.log(e);
      });
  };

  // Succesfull submission container
  const submittedContainer = (
    <div className={css.formSubmitted}>
      <div className={css.formSuccessMessage}>
        <IconSuccess />
        <p className={css.formSubmittedMessage}>
          <FormattedMessage id="ContactPage.formSubmittedMessage" />
        </p>
      </div>
      <Button
        className={css.successButton}
        onClick={() => setContactFormSubmitted(!isContactFormSubmitted)}
      >
        <FormattedMessage id="ContactPage.submitForm" />
      </Button>
    </div>
  );

  const schemaTitle = intl.formatMessage(
    {
      id: 'ContactPage.schemaTitle',
    },
    { siteTitle }
  );
  const schemaDescription = intl.formatMessage({
    id: 'ContactPage.schemaDescription',
  });

  const headerTitle = intl.formatMessage({ id: 'ContactPage.headerTitle' });
  const mailLink = (
    <ExternalLink href="mailto:hello@revelo.cc" className={css.count}>
      <FormattedMessage id="ContactPage.mail" />
    </ExternalLink>
  );

  return (
    <StaticPage
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactPage',
        description: schemaDescription,
        name: 'ContactPage',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.staticPageWrapper}>
          <StaticPageHeader
            titleClassName={css.headerTitle}
            title={headerTitle}
            currentPage="ContactPage"
            heroImage={heroImage}
            largeHeader
          />

          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p>
                <FormattedMessage id="ContactPage.sideText" values={{ mail: mailLink }} />
              </p>
            </div>

            <div className={css.contentMain}>
              <h3 className={css.pageTitle}>
                <FormattedMessage id="ContactPage.contentTitle" />
              </h3>
              {isContactFormSubmitted ? (
                submittedContainer
              ) : (
                <ContactForm
                  inProgress={sendContactEmailInProgress}
                  sendMessageError={sendContactEmailError}
                  onSubmit={handleSubmit}
                />
              )}
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

ContactPageComponent.propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  const { sendContactEmailInProgress, sendContactEmailError } = state.user;

  return {
    isAuthenticated,
    sendContactEmailInProgress,
    sendContactEmailError,
  };
};

const mapDispatchToProps = dispatch => ({
  onSendContactEmail: params => dispatch(sendContactEmail(params)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ContactPage = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ContactPageComponent);

export default ContactPage;
